import { useDecision } from '@optimizely/react-sdk'

import { useAuth } from 'routes/Menu/domains/auth'

const MENU_UNSAVED_CHANGES_PROMPT_FLAG = 'turnips_ofx_menu_unsaved_changes_prompt'

export const useUnsavedChangesPrompt = () => {
  const { isAuthenticated } = useAuth()
  const [featureFlagDecision] = useDecision(MENU_UNSAVED_CHANGES_PROMPT_FLAG)

  return isAuthenticated && featureFlagDecision.variationKey === 't1'
}
